<template>
  <main>
    <div class="container">
      <div class="row py-3 py-sm-5">
        <div class="col-12">
          <h1 class="text-white text-center">
            Login
          </h1>
        </div>
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <LoginForm />
    </div>
  </main>
</template>

<script>
import LoginForm from "../components/LoginForm.vue";

export default {
  components: {
    LoginForm,
  },
}
</script>
